import classNames from "classnames"
import { WearableModalType } from "../types"
import WearableContentInfo from "../WearableContentInfo"

type WearableUnknownInfoProps = {
   wearableId: string
}

const WearableUnknownInfo = ({ wearableId }: WearableUnknownInfoProps) => {
   return (
      <WearableContentInfo
         type={WearableModalType.UNKNOWN}
         description={
            <div
               className={classNames(
                  "wearable-content-info__description",
                  "wearable-content-info__description--unknown"
               )}
            >
               <span>Unable to identify ReassureBand:</span>
               <div>{wearableId}</div>
               <span>Please contact your administrator.</span>
            </div>
         }
      />
   )
}

export default WearableUnknownInfo
